<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-5 col-5">
                    <h6 class="h2 d-inline-block mb-0">Record</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-7 col-7 text-right">
                    <router-link :to="{ name: 'number_mapping' }" class="btn btn-sm" v-if="isDtacAdmin">
                        <base-button size="md" type="neutral">{{ $t("bc_mapping_number") }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <h3 class="mb-0">Report</h3>
                    </template>
                    <div>
                        <div class="col-xl-12">
                            <div class="row">
                                <div class="col-md-2" v-if="isDtacAdmin || isReadOnly">
                                    <base-input :label="$t('report.enterprise')">
                                        <el-select v-model="MainEnterpriseID" filterable
                                            :placeholder="$t('report.enterprise')">
                                            <el-option v-for="option in corporateMain" :key="option.ID"
                                                :label="option.Name" :value="option.ID">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-md-2" v-if="
                                    (isDtacAdmin || isReadOnly) &&
                                    corporateSub.length > 0 &&
                                    MainEnterpriseID != ''
                                ">
                                    <base-input :label="$t('report.enterprise_sub')">
                                        <el-select v-model="SubEnterpriseID" filterable
                                            :placeholder="$t('report.enterprise')">
                                            <el-option label="All" value="0"></el-option>
                                            <el-option v-for="option in corporateSub" :key="option.ID"
                                                :label="option.Name" :value="option.ID">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-md-2" v-if="isCorporateSuperAdmin">
                                    <base-input :label="$t('report.enterprise')">
                                        <el-select v-model="EnterpriseID" filterable
                                            :placeholder="$t('report.enterprise')">
                                            <el-option label="All" value="0"></el-option>
                                            <el-option v-for="option in corporate" :key="option.ID" :label="option.Name"
                                                :value="option.ID">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-md-2">
                                    <base-input :label="$t('report.number')" v-model="number" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-2">
                                    <base-input :label="$t('report.start')">
                                        <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                            :config="{ allowInput: true }" class="form-control datepicker"
                                            v-model="start_date">
                                        </flat-picker>
                                    </base-input>
                                </div>
                                <div class="col-md-2">
                                    <base-input :label="$t('report.end')">
                                        <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                            :config="{ allowInput: true }" class="form-control datepicker"
                                            v-model="end_date">
                                        </flat-picker>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-11">
                                    <base-button type="info" @click="handleSearch()">{{
                                        $t("report.search")
                                        }}</base-button>
                                    <base-button v-if="tableData.length > 0" type="info" @click="handleExport()">{{
                                        $t("report.export")
                                        }}</base-button>
                                    <base-button v-if="tableData.length > 0" type="info" @click="handleExportCDR()">{{
                                        $t("report.export")
                                        }}
                                        (Debug)</base-button>

                                    <strong>
                                        <div class="col-md-12">
                                            * {{ $t("report.date_warning") }}
                                        </div>
                                    </strong>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-md-2">
                                    <base-input :label="$t('report.call_type')" label-for="call_type">
                                        <select class="form-control" id="call_type" v-model="call_type">
                                            <option value="1">{{ $t("report.inbound") }}</option>
                                            <option value="2">{{ $t("report.outbound") }}</option>
                                            <option value="3">{{ $t("report.internal") }}</option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>

                            <br />

                            <!-- ============= In Bound Chart ============== -->
                            <div v-if="call_type == 1">
                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">{{ $t("report.inbound_answer") }}</h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Inbound[0].ChartData"
                                            :extra-options="Inbound[0].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">{{ $t("report.inbound_abandon") }}</h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Inbound[1].ChartData"
                                            :extra-options="Inbound[1].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">
                                            {{ $t("report.inbound_talk_time_avg") }}
                                        </h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Inbound[2].ChartData"
                                            :extra-options="Inbound[2].ChartOptions" />
                                    </div>
                                </card>
                            </div>

                            <!-- ============= Out Bound Chart ============== -->
                            <div v-if="call_type == 2">
                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">{{ $t("report.outbound_answer") }}</h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Outbound[0].ChartData"
                                            :extra-options="Outbound[0].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">{{ $t("report.outbound_abandon") }}</h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Outbound[1].ChartData"
                                            :extra-options="Outbound[1].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">
                                            {{ $t("report.outbound_talk_time_avg") }}
                                        </h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Outbound[2].ChartData"
                                            :extra-options="Outbound[2].ChartOptions" />
                                    </div>
                                </card>
                            </div>

                            <!-- ============= Internal Chart ============== -->
                            <div v-if="call_type == 3">
                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">{{ $t("report.internal_answer") }}</h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Internal[0].ChartData"
                                            :extra-options="Internal[0].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">{{ $t("report.internal_abandon") }}</h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Internal[1].ChartData"
                                            :extra-options="Internal[1].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">
                                            {{ $t("report.internal_talk_time") }}
                                        </h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Internal[2].ChartData"
                                            :extra-options="Internal[2].ChartOptions" />
                                    </div>
                                </card>

                                <card>
                                    <template slot="header">
                                        <!-- Title -->
                                        <h5 class="h3 mb-0">
                                            {{ $t("report.internal_talk_time_avg") }}
                                        </h5>
                                    </template>
                                    <div class="chart">
                                        <line-chart :height="350" :chart-data="Internal[3].ChartData"
                                            :extra-options="Internal[3].ChartOptions" />
                                    </div>
                                </card>
                            </div>
                        </div>
                        <br />

                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light"
                            @sort-change="sortChange">
                            <el-table-column v-for="column in tableColumn" :key="column.prop" :label="column.label"
                                :prop="column.prop" :min-width="column.minWidth">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            " v-if="report_type == 1">
                        <div class="" v-if="total != 0">
                            <p class="card-category">
                                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                                <span v-if="selectedRows.length">
                                    &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total" v-if="total != 0">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PagingReport/clientPaginationMixin";
import BarChart from "@/components/Charts/BarChart";
import LineChart from "@/components/Charts/LineChart";
// import HorizentalBarChart from "@/components/Charts/HBarChart";
import swal from "sweetalert2";
// import users from "./record";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapActions } from "vuex";
// import reportData from "./report_data";
import { utils, writeFile } from "xlsx";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        BarChart,
        LineChart,
        // HorizentalBarChart,
        flatPicker,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    mounted() {
        console.log(this.inbound_answer_call);

        console.log("isCorporateSuperAdmin", this.isCorporateSuperAdmin);
        console.log("isDtacAdmin", this.isDtacAdmin);
        console.log("isReadOnl", this.isReadOnly);

        this.report_type = 2;
        const today = new Date();
        this.start_date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
        this.end_date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
        this.listCorporate();
        this.clearReport();
    },
    watch: {
      number: function(val) {
        this.number = val.replace(/\D/g, "");
      },
},
    computed: {
        ...mapGetters({
            corporate: "Corporate/getData",
            isWaiting: "Cdr/isWaiting",
            isCorporateSuperAdmin: "Auth/isCorporateSuperAdmin",
            isDtacAdmin: "Auth/isDtacAdmin",
            isReadOnly: "Auth/isReadOnly",
            getReportCDR: "Report/getReportCDR",
            getReportCDRRaw: "Report/getReportCDRRaw",
            getReportSummary: "Report/getReportSummary",
            getReportDashboard: "Report/getReportDashboard"
        }),

        corporateMain: function () {
            return this.corporate.filter(item => item.UpperID == 0);
        },
        corporateSub: function () {
            return this.corporate.filter(
                item =>
                    item.UpperID == this.MainEnterpriseID ||
                    item.ID == this.MainEnterpriseID
            );
        },
        isEnterpriseMain: function () {
            try {
                let enterprise = this.corporate.find(
                    item => item.ID == this.MainEnterpriseID
                );
                return enterprise.UpperID == 0;
            } catch {
                return false;
            }
        },

        tableInbound: function () {
            return this.getReportSummary != null
                ? this.getReportSummary.map(it => {
                    return {
                        Date: it.date,
                        AnswerCall: it.call_detail.incomming.number_of_answer,
                        AbandonCall: it.call_detail.incomming.number_of_unanswer,
                        AvgTime: it.call_detail.incomming.talk_time_avg
                    };
                })
                : [];
        },
        tableOutbound: function () {
            return this.getReportSummary != null
                ? this.getReportSummary.map(it => {
                    return {
                        Date: it.date,
                        AnswerCall: it.call_detail.outgoing.number_of_answer,
                        AbandonCall: it.call_detail.outgoing.number_of_unanswer,
                        AvgTime: it.call_detail.outgoing.talk_time_avg
                    };
                })
                : [];
        },
        tableInternal: function () {
            return this.getReportSummary != null
                ? this.getReportSummary.map(it => {
                    return {
                        Date: it.date,
                        AnswerCall: it.call_detail.internal.number_of_answer,
                        AbandonCall: it.call_detail.internal.number_of_unanswer,
                        AvgTime: it.call_detail.internal.talk_time_avg,
                        TalkTimePerDay: it.call_detail.internal.talk_time
                    };
                })
                : [];
        },
        tableData: function () {
            if (this.call_type == 1) {
                return this.getReportSummary != null
                    ? this.getReportSummary.map(it => {
                        return {
                            Date: it.date,
                            AnswerCall: it.call_detail.incomming.number_of_answer,
                            AbandonCall: it.call_detail.incomming.number_of_unanswer,
                            AvgTime: it.call_detail.incomming.talk_time_avg
                        };
                    })
                    : [];
            } else if (this.call_type == 2) {
                return this.getReportSummary != null
                    ? this.getReportSummary.map(it => {
                        return {
                            Date: it.date,
                            AnswerCall: it.call_detail.outgoing.number_of_answer,
                            AbandonCall: it.call_detail.outgoing.number_of_unanswer,
                            AvgTime: it.call_detail.outgoing.talk_time_avg
                        };
                    })
                    : [];
            } else if (this.call_type == 3) {
                return this.getReportSummary != null
                    ? this.getReportSummary.map(it => {
                        return {
                            Date: it.date,
                            AnswerCall: it.call_detail.internal.number_of_answer,
                            AbandonCall: it.call_detail.internal.number_of_unanswer,
                            AvgTime: it.call_detail.internal.talk_time_avg,
                            TalkTimePerDay: it.call_detail.internal.talk_time
                        };
                    })
                    : [];
            }
            return [];
        },

        // tableData: function() {
        //   let report_data = [];
        //   if (this.call_type == 1) {
        //     // loop get data from reportData
        //     for (let i = 0; i < 7; i++) {
        //       let row = {
        //         Date: reportData.date[i],
        //         AnswerCall: reportData.inbound[0].data[i],
        //         AbandonCall: reportData.inbound[1].data[i],
        //         AvgTime: reportData.inbound[2].data[i]
        //       };
        //       report_data.push(row);
        //     }
        //   } else if (this.call_type == 2) {
        //     // loop get data from outbound
        //     for (let i = 0; i < 7; i++) {
        //       let row = {
        //         Date: reportData.date[i],
        //         OutgoingCall: reportData.outbound[0].data[i],
        //         AvgTime: reportData.outbound[1].data[i]
        //       };
        //       report_data.push(row);
        //     }
        //   } else if (this.call_type == 3) {
        //     // loop get data from internal
        //     for (let i = 0; i < 7; i++) {
        //       let row = {
        //         Date: reportData.date[i],
        //         InternalCall: reportData.internal[0].data[i],
        //         TalkTimePerDay: reportData.internal[1].data[i],
        //         AvgTime: reportData.internal[1].data[i]
        //       };
        //       report_data.push(row);
        //     }
        //   }

        //   return report_data;
        // },

        tableColumn: function () {
            if (this.call_type == 1) {
                return [
                    {
                        prop: "Date",
                        label: this.$t("report.call_dates"),
                        minWidth: 120
                    },
                    {
                        prop: "AnswerCall",
                        label:
                            this.$t("report.inbound_answer") + this.$t("report.unit_call"),
                        minWidth: 160
                    },
                    {
                        prop: "AbandonCall",
                        label:
                            this.$t("report.inbound_abandon") + this.$t("report.unit_call"),
                        minWidth: 160
                    },
                    {
                        prop: "AvgTime",
                        label:
                            this.$t("report.inbound_talk_time_avg") +
                            this.$t("report.unit_min"),
                        minWidth: 160
                    }
                ];
            } else if (this.call_type == 2) {
                return [
                    {
                        prop: "Date",
                        label: this.$t("report.call_dates"),
                        minWidth: 120
                    },
                    {
                        prop: "AnswerCall",
                        label:
                            this.$t("report.outbound_answer") + this.$t("report.unit_call"),
                        minWidth: 160
                    },
                    {
                        prop: "AbandonCall",
                        label:
                            this.$t("report.outbound_abandon") + this.$t("report.unit_call"),
                        minWidth: 160
                    },
                    {
                        prop: "AvgTime",
                        label:
                            this.$t("report.outbound_talk_time_avg") +
                            this.$t("report.unit_min"),
                        minWidth: 160
                    }
                ];
            } else if (this.call_type == 3) {
                return [
                    {
                        prop: "Date",
                        label: this.$t("report.call_dates"),
                        minWidth: 120
                    },
                    {
                        prop: "AnswerCall",
                        label:
                            this.$t("report.internal_answer") + this.$t("report.unit_call"),
                        minWidth: 160
                    },
                    {
                        prop: "AbandonCall",
                        label:
                            this.$t("report.internal_abandon") + this.$t("report.unit_call"),
                        minWidth: 160
                    },
                    {
                        prop: "TalkTimePerDay",
                        label:
                            this.$t("report.internal_talk_time") + this.$t("report.unit_min"),
                        minWidth: 160
                    },
                    {
                        prop: "AvgTime",
                        label:
                            this.$t("report.internal_talk_time_avg") +
                            this.$t("report.unit_min"),
                        minWidth: 160
                    }
                ];
            }
        },

        Inbound: function () {
            return [
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "Answer Call",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.incomming.number_of_answer;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "UnAnswer Call",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.incomming.number_of_unanswer;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "Talk Time",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.incomming.talk_time_avg;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                }
            ];
        },
        Outbound: function () {
            return [
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "Answer Call",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.outgoing.number_of_answer;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "UnAnswer Call",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.outgoing.number_of_unanswer;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "Talk Time",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.outgoing.talk_time_avg;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                }
            ];
        },
        Internal: function () {
            return [
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "Answer Call",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.internal.number_of_answer;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "UnAnswer Call",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.internal.number_of_unanswer;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "Talk Time",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.internal.talk_time;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    ChartData: {
                        labels:
                            this.getReportSummary != null
                                ? this.getReportSummary.map(it => {
                                    return it.date;
                                })
                                : [],
                        datasets: [
                            {
                                label: "AVG Talk Time",
                                data:
                                    this.getReportSummary != null
                                        ? this.getReportSummary.map(it => {
                                            return it.call_detail.internal.talk_time_avg;
                                        })
                                        : [],
                                pointRadius: 8,
                                pointHoverRadius: 12,
                                showLine: true,
                                lineTension: 0
                            }
                        ]
                    },
                    ChartOptions: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true
                                    }
                                }
                            ]
                        }
                    }
                }
            ];
        }
    },
    data() {
        return {
            EnterpriseID: "",
            MainEnterpriseID: "",
            SubEnterpriseID: "",
            report_type: 1,
            call_type: 1,
            call_status: 0,
            performance_report_type: 1,
            start_date: "",
            end_date: "",
            number: "",
            charging_group: "",
            isShowWating: false,
            extraOptionsByNumber: {
                responsive: true,
                scales: {
                    yAxes: [
                        {
                            scaleLabel: {
                                display: true,
                                labelString: this.$t("report.number_of_calls")
                            }
                        }
                    ]
                }
            },
            extraOptions: {
                tooltips: {
                    mode: "index",
                    intersect: false
                },
                responsive: true,
                scales: {
                    xAxes: [
                        {
                            stacked: false
                        }
                    ],
                    yAxes: [
                        {
                            stacked: false,
                            scaleLabel: {
                                display: true,
                                labelString: this.$t("report.number_of_calls")
                            }
                        }
                    ]
                }
            },

            RecordChart: {},
            propsToSearch: ["name", "email", "age"],
            selectedRows: [],
            stateTimerCount: 0,
            state: 0 // 1=processing // 2=succes
        };
    },
    methods: {
        ...mapActions({
            listCdr: "Report/listReportCDR",
            clearReport: "Report/clearReportSummary",
            listCorporate: "Corporate/listData"
        }),
        handleExportCDR() {
            const dataWS = utils.json_to_sheet(this.getReportCDR);
            const dataRawWS = utils.json_to_sheet(this.getReportCDRRaw);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, dataWS, "CDR");
            utils.book_append_sheet(wb, dataRawWS, "CDR Raw");
            writeFile(wb, `export_debug.xlsx`);
        },
        handleExport() {
            // convert table data to csv
            const dataInbound = utils.json_to_sheet(this.tableInbound);
            const dataOutbond = utils.json_to_sheet(this.tableOutbound);
            const dataInternal = utils.json_to_sheet(this.tableInternal);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, dataInbound, "Inbound");
            utils.book_append_sheet(wb, dataOutbond, "Outbound");
            utils.book_append_sheet(wb, dataInternal, "Internal");
            writeFile(wb, `export_data.xlsx`);
        },

        handleSearch(index, row) {
            const date1 = new Date(this.start_date);
            const date2 = new Date(this.end_date);
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays > 90) {
                swal.fire({
                    title: this.$t("errors.invalid_date_range_over_90"),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-info btn-fill"
                });
                return;
            }

            let eid = 0;
            let eid_sub = 0;
            if (this.isDtacAdmin || this.isReadOnly) {
                eid = this.MainEnterpriseID;
                eid_sub = this.SubEnterpriseID;
            } else if (this.isCorporateSuperAdmin) {
                eid = this.EnterpriseID;
            } else {
                // enterprise admin can't select
            }

            let params = {
                enterprise_id: eid,
                enterprise_id_sub: eid_sub,
                start_date: this.start_date,
                end_date: this.end_date,
                number: this.number,
                full_report: 1
            };
            this.listCdr(params);
        }
    }
};
</script>

<style scoped>
.form-group {
    margin-bottom: 0.2rem !important;
}

.no-border-card .card-footer {
    border-top: 0;
}
</style>
